<template>
  <div class="h-screen w-full">
    <iframe 
      src="https://preview--casa-azul-hero-system.lovable.app/login" 
      class="w-full h-full border-0"
      title="Selo Casa Azul"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SeloCasaAzul',
  mounted() {
    document.title = 'Selo Casa Azul - Plataforma Circular';
  }
}
</script>